// Lounge: carpete na sala toda, com um canto de jogos de carpete azul (TV, cadeiras gamer). Sofá e poltronas ficam no alto, de frente para a mesa de centro; mesa de pingue-
// pongue no meio, fliperama e estante de jogos na parede do lado direito.

import type { RoomMap, Spot } from '../../core/world.js';

// Quem joga pingue-pongue fica em pé dos dois lados da mesa, virado para ela.
const PINGPONG_SPOTS: readonly Spot[] = [
  { id: 'lounge:pingpong-0', x: 8, y: 3, facing: 'right', kind: 'standing', use: 'rest' },
  { id: 'lounge:pingpong-1', x: 12, y: 4, facing: 'left', kind: 'standing', use: 'rest' },
];

export const LOUNGE: RoomMap = {
  id: 'lounge',
  kind: 'lounge',
  name: 'Lounge',
  // c = carpete (sala), a = carpete azul (canto de jogos)
  floor: [
    'cccccccccccccccc',
    'cccccccccccccccc',
    'cccccccccccccccc',
    'cccccccccccccccc',
    'cccccccccccccccc',
    'cccccccccccccccc',
    'ccccccccccccaaaa',
    'ccccccccccccaaaa',
    'ccccccccccccaaaa',
    'ccccccccccccaaaa',
  ],
  legend: { c: 'carpete', a: 'carpete-azul' },
  items: [
    // parede norte: quadro, duas janelas e pôster
    { item: 'quadro-paisagem', x: 2, y: 0 },
    { item: 'janela', x: 5, y: 0 },
    { item: 'poster-agzos', x: 9, y: 0 },
    { item: 'janela', x: 12, y: 0 },
    // sofá verde de frente para a mesa de centro, poltrona e luminária de pé
    { item: 'luminaria-chao', x: 0, y: 1 },
    { item: 'sofa-verde', x: 2, y: 1 },
    { item: 'mesa-centro', x: 3, y: 2 },
    { item: 'poltrona', x: 6, y: 2 },
    { item: 'poltrona', x: 1, y: 3 },
    // tapete com pufes em volta (o tapete não bloqueia: pode ficar embaixo de tudo)
    { item: 'tapete-lounge', x: 2, y: 5 },
    { item: 'pufe', x: 2, y: 6 },
    { item: 'pufe', x: 4, y: 6 },
    // pingue-pongue no meio da sala
    { item: 'mesa-pingpong', x: 9, y: 3 },
    // lado direito: fliperama e estante de jogos na parede
    { item: 'fliperama', x: 13, y: 1 },
    { item: 'estante-games', x: 15, y: 1 },
    // canto de jogos: TV, duas cadeiras gamer e uma planta
    { item: 'rack-tv', x: 13, y: 8 },
    { item: 'cadeira-gamer', x: 13, y: 7 },
    { item: 'cadeira-gamer', x: 14, y: 7 },
    { item: 'planta-grande', x: 0, y: 9 },
    { item: 'vaso-alto', x: 0, y: 5 },
    { item: 'planta-grande', x: 15, y: 5 },
    { item: 'planta-vaso', x: 15, y: 9 },
  ],
  doors: [{ x: 7, y: 9 }],
  spots: [
    ...PINGPONG_SPOTS,
    { id: 'lounge:gamer-0', x: 13, y: 7, facing: 'down', kind: 'chair', use: 'rest' },
    { id: 'lounge:gamer-1', x: 14, y: 7, facing: 'down', kind: 'chair', use: 'rest' },
  ],
};
